module.exports = __webpack_public_path__ + "img/425.74910904.png";